export const getCurrency = (id, currencies) => currencies?.find((currency) => currency.id === id);
